import React, {FC} from "react";
import {
  AdminApiContext,
  CollaborativeFormEditorPrimer,
  GregPrimerTheme
} from "@getregistered/greg-editors";
import {AwarenessUsers} from "../AwarenessUsers";
import ErrorHandler from "../ErrorHandler";
import {EditorUIProps} from "./types";

export const PrimerEditor: FC<EditorUIProps> = ({apiClient, ...props}) => {

  return (<ErrorHandler>
      <GregPrimerTheme>
        <AdminApiContext.Provider value={apiClient}>
          <CollaborativeFormEditorPrimer {...props} />
        </AdminApiContext.Provider>
      </GregPrimerTheme>
    </ErrorHandler>
  )
}